import { LoginApi } from '../api';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const LoginMethods = async (
    e: any,
    formRef: any,
    navigate: (str: string) => void,
    setDisplayBtn: (bol: boolean) => void,
    qr_code: any
) => {
    e.preventDefault()
    setDisplayBtn(true)
    let res = await LoginApi(formRef)
    setDisplayBtn(false)
    if (res.data.status == "OK") {
        localStorage.setItem('user', JSON.stringify(res.data.data[0]))
        localStorage.setItem('token', res.data.data[0].token)
        if (qr_code != null && qr_code != "") {            
            sessionStorage.setItem('qr', qr_code)
        }
        navigate('/p/record');
    }
    else {
        toast(res.data.message, { type: "error" })
    }
}